import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PlanCard from "./PlanCard";
import { getSavedPlans } from "../../../state/actions/plans/plans";

export function PlanCardsList(props) {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(
        (state) => state.authReducer.isAuthenticated
    );

    // get user plans
    useEffect(() => {
        if (isAuthenticated && !props.noFetchSaved) {
            dispatch(getSavedPlans());
        }
    }, [props.isAuthenticated, `${props.plans}`]);

    return (
        <section
            id="plan-cards"
            className="section section-lg py-3 py-md-6 bg-soft"
        >
            <div className="container z-2">
                <div className="row justify-content-center">
                    {props.plans.map((plan, index) => (
                        <PlanCard
                            {...plan}
                            key={plan.id}
                            planPath={props.planPath}
                            priorityImage={index < 3}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PlanCardsList;
